// Plain-language text for the QuickBooks connection panel: when the last sync finished and how it went.
// Pure: no database, no browser. `now` is passed in so it can be tested.

export function lastSyncedText(iso, now = new Date()) {
  const t = Date.parse(iso || '');
  if (!iso || Number.isNaN(t)) return 'Not synced yet';
  const minutes = Math.floor((now.getTime() - t) / 60000);
  if (minutes < 1) return 'Last synced just now';
  if (minutes < 60) return `Last synced ${minutes} minute${minutes === 1 ? '' : 's'} ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `Last synced ${hours} hour${hours === 1 ? '' : 's'} ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `Last synced ${days} day${days === 1 ? '' : 's'} ago`;
  return `Last synced ${new Date(t).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}`;
}

// A short line about the steps that did not finish, or '' when everything did.
export function syncProblemsText(problems) {
  if (!Array.isArray(problems) || problems.length === 0) return '';
  if (problems.some(p => p && p.code === 'quickbooks_disconnected')) {
    return 'QuickBooks needs to be connected again before Canopy can sync.';
  }
  if (problems.some(p => p && p.code === 'sync_failed')) {
    return "The last sync couldn't finish. Some job costs may be out of date. Choose Sync QuickBooks now to try again.";
  }
  return "The last sync finished, but some steps didn't complete, so some job costs may be out of date. Choose Sync QuickBooks now to try again.";
}
